import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import styles from "./UpcomingCourses.module.css";
import { useRouter } from "next/navigation";
import Grid from '@mui/material/Grid';

const UpcomingCourses = () => {
  const router = useRouter();
  return (
    <div className={styles.WhiteSection}>
      <div className={styles.Container}>
        <div className={styles.Title}>Upcoming Courses</div>

        <div className={styles.CardContainer}>


          <div className={styles.CardContainer}>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-dr-najat-fradi-dealing-with-teenagers-soon.webp"
                alt="Dr. Najat Fradi"
              />
            </div>


            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-kaushar-tai-parenting-autism-adhd-soon.webp"
                alt="Kaushar Tai"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-alaa-irsheid-arabic-beginners-soon.webp"
                alt="Ala'a Jehad"
              />
            </div>


            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-kathryn-jones-resilient-parenting-soon.webp"
                alt="Kathryn Jones"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-prof-aminah-al-deen-faith-over-fear-soon.webp"
                alt="Prof Aminah Al Deen"
              />
            </div>


            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-halim-rane-covenants-with-allah-coming-soon.webp"
                alt="Dr. Halim Tana"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-javeria-ahmed-islam-conflict-peacebuilding-soon.webp"
                alt="Javeria Ahmed"
              />
            </div>

            {/* <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-dr-laura-gibb-dr-nikita-islam-ready-to-blossom-soon.webp"
                alt="Dr. Laura Gibb"
              />
            </div> */}

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-imam-saeed-purcell-marriage-relationship-basics-soon.webp"
                alt="Imam Saeed Purcell"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-naima-b-robert-fundamentals-of-writing-soon.webp"
                alt="Naima B Robert"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-ustadh-abusamihah-sirajul-islam-40-hadith-course-soon.webp"
                alt="AbuSamihah Sirajul Islam"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-dr-abu-talib-monawer-maqasid-al-shariah-soon.webp"
                alt="Dr Abu Talib Muhammad Monawer"
              />
            </div>


            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-kamrul-hasan-master-mind-soon.webp"
                alt="Kamrul Hasan"
              />
            </div>

            <div className={styles.Card}>
              <img
                src="https://cdn.mytakbir.com/static-assets/upcoming-courses/takbir-learn-teach-online-dr-haroon-khan-families-finance-soon.webp"
                alt="Dr. Haroon Khan"
              />
            </div>

          </div>
          {/* Container End */}

        </div>

        <div className={styles.ButtonBox}>
          <button
            className={styles.BottomButton}
            onClick={() => router.push("/search")}
          >
            Explore all courses
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpcomingCourses;
